<script lang="ts">
    import { Chart } from "chart.js";
    import { onMount } from "svelte";

    export let label: string;
    export let labels: any[];
    export let data: any[];

    let ctx;
    
    onMount(() => {
        const myChart = new Chart(ctx, {
            type: "bar",
            data: {
                labels,
                datasets: [
                    {
                        label,
                        data,
                        backgroundColor: "rgba(67, 0, 176, 0.03);",
                        borderColor: "rgba(67, 0, 176, 0.25)",
                        borderWidth: 1,
                    },
                ],
            },
            options: {
                scales: {
                    y: {
                        beginAtZero: true
                    },
                }
            },
        });
    });
</script>

<canvas bind:this={ctx} width="400" height="200" />
